import React from 'react';
import '../App.css';
import {
    Row,
    Col
} from 'bootstrap-4-react';
import builder from '../builder.svg'
import manager from '../manager-2.svg'
import student from '../student.svg'

function ForRow() {

    return (
        <Row id="forRow">
            <Col col={'md-4'}>
                <h3 className={'rowTitle'}>
                    Вебинар будет интересным
                </h3>
            </Col>
            <Col col={'md-8'}>
              <div className={ 'forItem' }>
                <img src={ student } height={ '70px' } alt={ 'builder logo' }/>
                <h4>Студентам и начинающим</h4>
              </div>
                <div className={'forItem'}>
                    <img src={builder} height={'70px'} alt={'builder logo'}/>
                    <h4>Для мастеров-отделочников и бригад, специалистов по ремонту</h4>
                </div>
                <div className={'forItem'}>
                    <img src={manager} height={'70px'} alt={'builder logo'}/>
                    <h4>Для предпринимателей и руководителей проектов строительных компаний</h4>
                </div>
            </Col>
        </Row>


    );
}

export default ForRow;
